import React, {useState,  useEffect} from 'react';
import PageTitle from '../../components/PageTitle';
import genStyles from '../../styles/General.module.css';
import {Button, Checkbox} from '@mantine/core';
import OperationsList from './OperationsList';
import OperationsPopUp from './OperationsPopUp';
import {useDisclosure } from '@mantine/hooks';
import { useNavigate } from 'react-router-dom';
import { useOperations } from '../../context/OperationsContext';

const baseUrl = process.env.REACT_APP_API_URL;

const OperationsPage = () =>{
    const [showPast, setShowPast] = useState<boolean>(false)
    const [opened, { open, close }] = useDisclosure(false);
    const {operations, addOperation} = useOperations()
    const navigate = useNavigate();




    //onsave TODO
    const onSave = async(sorter: number|null, belt:number|null, recipe:number|null, time:string|null, status:number|null) =>{
        const newId = await addOperation(sorter||-1, belt||-1, recipe||-1, time||String(new Date()), status||-1)
        navigate(`/operations/${newId}?recipeId=${recipe}`);
        
    }

    return (
        <div>
            <OperationsPopUp opened={opened} close={close} title="New Operation" onSave={onSave}  ></OperationsPopUp>
            <PageTitle title="SorterOperations"></PageTitle>
            <div className={genStyles.PageMain}>
                <Checkbox className={genStyles.Checkbox} label="Show past operations" checked={showPast} onChange={(event) => setShowPast(event.currentTarget.checked)}  color="rgba(98, 146, 158, 1)"/>
                <OperationsList data={operations} showPast={showPast} ></OperationsList>
                <div className={genStyles.AddButtonWrapper}> 
                 <Button className ={genStyles.AddButton} onClick={open} variant="filled" color="#62929E" radius="xl">Start new Operation</Button>
                </div> 
            </div>
        </div>

    );
}

export default OperationsPage